import MediaMathHelpers from "../../Helpers/MediaMathHelpers";
import CascadingChange from "../../Helpers/CascadingChangeHelper";
import MasterCampaignsStore from "../../Flux/Stores/MasterCampaignsStore";

const UpdateStateHelper = {
	update: (dataConfig, name, value, id, dataType, calc, formEl, self, disabled, config, disableDelete = false, setStateCallback) => {
		if (name !== "PackageName") {
			// Check if we have anything in the bucket first, if not just create an empty object so it doesn't bomb out
			const postDataBucket = self.state.postData[dataConfig] ? self.state.postData[dataConfig] : {};
			// Set Default Variable
			let postDataValue;

			// We want Numbers to fallback to 0 for POST purposes
			if (dataType === "Currency" || dataType === "Integer") {
				postDataValue = value || 0;
			} else {
				postDataValue = value || null;
			}

			// We want to Disable the field when a Parent Object is selected
			let isDisabled = false;
			if (disabled) {
				isDisabled = true;
			}
			// If we have a nested value it's a dropdown object so let's get the ID for the POST
			if (value) {
				if (value.value) {
					postDataValue = value.value;
				}
			}
			let parentName = null;
			if (dataConfig === "MetaData" || dataConfig === "TaxonomyData") {
				if (config && config[dataConfig]) {
					config[dataConfig].forEach((field) => {
						if (name === field.Name) {
							if (field.ParentName !== null) {
								parentName = field.ParentName;
							}
						}
					});
				}
			}

			if (dataConfig === "TaxonomyData" || dataConfig === "MetaData") {
				/* Handle Select's Object */
				if (dataType === "Select") {
					if (postDataValue === null) {
						delete postDataBucket[name];
					} else {
						Object.assign(postDataBucket, {
							[name]: {
								dataKeyID: id,
								dataValue: {
									dataValueID: postDataValue
								},
								parentName
							}
						});
					}
					if (disableDelete === false) {
						CascadingChange.cascadingDelete(self, name);
					}
				} else if (postDataValue === null) {
					delete postDataBucket[name];
				} else {
					Object.assign(postDataBucket, {
						[name]: {
							dataKeyID: id,
							dataValueIfFreeForm: postDataValue
						}
					});
				}

				self.setState(
					{
						formData: {
							...self.state.formData,
							[name]: {
								value,
								disabled: isDisabled,
								parentName
							}
						},
						postData: {
							...self.state.postData,
							[dataConfig]: postDataBucket
						}
					},
					() => {
						if (!calc) {
							if (self.props.metaData) {
								if (self.props.metaData.Budget) {
									if (self.props.metaData.Budget !== null && self.props.metaData.Budget !== 0) {
										MediaMathHelpers.mediaMathWrapper(name, value, self, UpdateStateHelper.update, dataConfig, formEl);
									}
								}
							}
						}
					}
				);
			} else if (postDataValue === null) {
				delete postDataBucket[name];
			} else if (dataType === "Select" && dataConfig !== "ParentData") {
				if (name === "PlatformSiteID") {
					Object.assign(postDataBucket, { [name]: value.value });
				} else {
					Object.assign(postDataBucket, { [name]: value.label });
				}
			} else {
				Object.assign(postDataBucket, { [name]: postDataValue });
			}

			// Parent/Child relationships are handled somewhat differently if they are in the audit level data as opposed to TaxonomyData or MetaData
			if (
				["AdSetData", "InsertionOrderData", "LineItemData", "CreativeData", "PackageData", "PlacementData"].includes(dataConfig) &&
				dataType === "Select" &&
				disableDelete === false
			) {
				CascadingChange.cascadingAuditLevelDelete(self, name, config[dataConfig], dataConfig);
			}

			self.setState(
				{
					formData: {
						...self.state.formData,
						[name]: {
							value,
							disabled: isDisabled,
							parentName
						}
					},
					postData: {
						...self.state.postData,
						[dataConfig]: postDataBucket
					}
				},
				() => {
					if (!calc) {
						if (self.props.metaData) {
							if (self.props.metaData.Budget) {
								if (self.props.metaData.Budget !== null && self.props.metaData.Budget !== 0) {
									MediaMathHelpers.mediaMathWrapper(name, value, self, UpdateStateHelper.update, dataConfig, formEl);
								}
							}
						}
					}
					if (setStateCallback) setStateCallback();
				}
			);
		}
	},
	updateAdvertiserFields: (dataConfig, name, value, id, dataType, formEl, self, advertiser, config) => {
		// Use functional setState so looped calls accumulate correctly.
		self.setState((prevState) => {
			const existingAdvertiserState = prevState[advertiser] || { formData: {}, postData: {} };
			const postDataBucket = existingAdvertiserState.postData[dataConfig] ? { ...existingAdvertiserState.postData[dataConfig] } : {};

			let postDataValue;
			if (dataType === "Currency" || dataType === "Integer") {
				postDataValue = value || 0;
			} else {
				postDataValue = value || null;
			}
			if (value && value.value) {
				postDataValue = value.value;
			}

			let parentName = null;
			if ((dataConfig === "MetaData" || dataConfig === "TaxonomyData") && config && config[dataConfig]) {
				config[dataConfig].forEach((field) => {
					if (name === field.Name && field.ParentName !== null) {
						parentName = field.ParentName;
					}
				});
			}

			if (dataConfig === "TaxonomyData" || dataConfig === "MetaData") {
				if (dataType === "Select") {
					if (postDataValue === null) {
						delete postDataBucket[name];
					} else {
						postDataBucket[name] = { dataKeyID: id, dataValue: { dataValueID: postDataValue }, parentName };
					}
				} else if (postDataValue === null) {
					delete postDataBucket[name];
				} else {
					postDataBucket[name] = { dataKeyID: id, dataValueIfFreeForm: postDataValue };
				}
			} else if (postDataValue === null) {
				delete postDataBucket[name];
			} else if (dataType === "Select" && dataConfig !== "ParentData") {
				if (name === "PlatformSiteID") {
					postDataBucket[name] = value.value;
				} else {
					postDataBucket[name] = value.label;
				}
			} else {
				postDataBucket[name] = postDataValue;
			}

			return {
				[advertiser]: {
					formData: { ...existingAdvertiserState.formData, [name]: { value, parentName } },
					postData: { ...existingAdvertiserState.postData, [dataConfig]: postDataBucket }
				}
			};
		});
	},
	updatev2: (editArray, formEl, self, config) => {
		const dataBuckets = Object.keys(config).filter((dataBucket) => {
			return dataBucket !== "ChildData";
		});
		const formattedBuckets = {};
		const formData = {};
		dataBuckets.forEach((dataBucket) => {
			formattedBuckets[dataBucket] = self.state.postData[dataBucket] ? self.state.postData[dataBucket] : {};
			editArray.forEach((field) => {
				if (field[1] !== "PackageName") {
					if (field[0] === dataBucket) {
						let postDataValue;

						const name = field[1];
						const value = field[2];
						const id = field[3];
						const dataType = field[4];
						const calc = field[5];
						const disabled = field[6];

						if (dataType === "Currency" || dataType === "Integer") {
							postDataValue = value || 0;
						} else {
							postDataValue = value || null;
						}
						let isDisabled = false;
						if (disabled) {
							isDisabled = true;
						}
						if (value) {
							if (value.value) {
								postDataValue = value.value;
							}
						}
						let parentName = null;
						if (dataBucket === "MetaData" || dataBucket === "TaxonomyData") {
							if (config && config[dataBucket]) {
								config[dataBucket].forEach((field) => {
									if (name === field.Name) {
										if (field.ParentName !== null) {
											parentName = field.ParentName;
										}
									}
								});
							}
						}
						if (dataBucket === "TaxonomyData" || dataBucket === "MetaData") {
							/* Handle Select's Object */
							if (dataType === "Select") {
								if (postDataValue === null) {
									delete formattedBuckets[dataBucket][name];
								} else {
									Object.assign(formattedBuckets[dataBucket], {
										[name]: {
											dataKeyID: id,
											dataValue: {
												dataValueID: postDataValue
											},
											parentName
										}
									});
									Object.assign(formData, {
										[name]: {
											value,
											disabled: isDisabled,
											parentName
										}
									});
								}
								CascadingChange.cascadingDelete(self, name);
							} else if (postDataValue === null) {
								delete formattedBuckets[dataBucket][name];
							} else {
								Object.assign(formattedBuckets[dataBucket], {
									[name]: {
										dataKeyID: id,
										dataValueIfFreeForm: postDataValue
									}
								});
								Object.assign(formData, {
									[name]: {
										value,
										disabled: isDisabled,
										parentName
									}
								});
							}
						} else if (postDataValue === null) {
							formattedBuckets[dataBucket][name];
						} else if (dataType === "Select" && dataBucket !== "ParentData") {
							if (name === "PlatformSiteID") {
								Object.assign(formattedBuckets[dataBucket], { [name]: value.value });

								Object.assign(formData, {
									[name]: {
										value,
										disabled: isDisabled,
										parentName
									}
								});
							} else {
								Object.assign(formattedBuckets[dataBucket], { [name]: value.label });

								Object.assign(formData, {
									[name]: {
										value,
										disabled: isDisabled,
										parentName
									}
								});
							}
						} else {
							Object.assign(formattedBuckets[dataBucket], { [name]: postDataValue });
							Object.assign(formData, {
								[name]: {
									value,
									disabled: isDisabled,
									parentName
								}
							});
						}
					}
				}
			});
		});
		self.setState({
			formData,
			postData: formattedBuckets,
			loading: false
		});
	},
	bulkUpdate: (fieldArray, config, self, fieldsFilledCallback) => {
		let postData = {};
		let formData = {};
		fieldArray.forEach((field) => {
			const dataConfig = field[0];
			const name = field[1];
			const value = field[2];
			const id = field[3];
			const dataType = field[4];
			if (name !== "PackageName") {
				// Check if we have anything in the bucket first, if not just create an empty object so it doesn't bomb out
				const postDataBucket = postData[dataConfig] ? postData[dataConfig] : {};
				// Set Default Variable
				let postDataValue;

				// We want Numbers to fallback to 0 for POST purposes
				if (dataType === "Currency" || dataType === "Integer") {
					postDataValue = value || 0;
				} else {
					postDataValue = value || null;
				}

				// We want to Disable the field when a Parent Object is selected
				const isDisabled = false;
				// if (disabled) {
				// 	isDisabled = true;
				// }
				// If we have a nested value it's a dropdown object so let's get the ID for the POST
				if (value) {
					if (value.value) {
						postDataValue = value.value;
					}
				}
				let parentName = null;
				if (dataConfig === "MetaData" || dataConfig === "TaxonomyData") {
					if (config && config[dataConfig]) {
						config[dataConfig].forEach((field) => {
							if (name === field.Name) {
								if (field.ParentName !== null) {
									parentName = field.ParentName;
								}
							}
						});
					}
				}

				if (dataConfig === "TaxonomyData" || dataConfig === "MetaData") {
					/* Handle Select's Object */
					if (dataType === "Select") {
						if (postDataValue === null) {
							delete postDataBucket[name];
						} else {
							Object.assign(postDataBucket, {
								[name]: {
									dataKeyID: id,
									dataValue: {
										dataValueID: postDataValue
									},
									parentName
								}
							});
						}
					} else if (postDataValue === null) {
						delete postDataBucket[name];
					} else {
						Object.assign(postDataBucket, {
							[name]: {
								dataKeyID: id,
								dataValueIfFreeForm: postDataValue
							}
						});
					}

					formData = {
						...formData,
						[name]: {
							value,
							disabled: isDisabled,
							parentName
						}
					};

					postData = {
						...postData,
						[dataConfig]: postDataBucket
					};
				} else if (postDataValue === null) {
					delete postDataBucket[name];
				} else if (dataType === "Select" && dataConfig !== "ParentData") {
					if (name === "PlatformSiteID") {
						Object.assign(postDataBucket, { [name]: value.value });
					} else {
						Object.assign(postDataBucket, { [name]: value.label });
					}
				} else {
					Object.assign(postDataBucket, { [name]: postDataValue });
				}

				formData = {
					...formData,
					[name]: {
						value,
						disabled: isDisabled,
						parentName
					}
				};

				postData = {
					...postData,
					[dataConfig]: postDataBucket
				};
			}
		});
		self.setState({ formData, postData }, () => {
			fieldsFilledCallback();
		});
	},
	matchParentCampaign: () => {
		const data = MasterCampaignsStore.getData();
		const masterCampaignID = MasterCampaignsStore.getMasterCampaignUniqueID();
		const parentCampaignID = MasterCampaignsStore.getParentCampaignUniqueID();
		let parentCampaign = null;
		data.forEach((masterCampaign) => {
			if (masterCampaign.MasterCampaignUniqueIDCode.toString() === masterCampaignID) {
				const activationCampaignKeys = Object.keys(masterCampaign.ActivationCampaigns);
				activationCampaignKeys.forEach((activation) => {
					masterCampaign.ActivationCampaigns[activation].forEach((campaign) => {
						if (campaign.CampaignUniqueCode === parentCampaignID) {
							parentCampaign = campaign;
						}
					});
				});
			}
		});
		return parentCampaign;
	},
	matchParentValues: (self, config, callback = () => {}) => {
		const parentCampaign = UpdateStateHelper.matchParentCampaign();
		const { formData } = self.state;
		const { postData } = self.state;
		const keysWithParent = {};
		Object.keys(config).forEach((dataBucketName) => {
			if (["TaxonomyData", "MetaData"].includes(dataBucketName) && Array.isArray(config[dataBucketName])) {
				config[dataBucketName].forEach((dataKey) => {
					if (dataKey.FieldType !== "Hidden" && parentCampaign[dataKey.Name]) {
						const parentValue = parentCampaign[dataKey.Name];
						let postDataValue = {};
						let formDataValue = {};
						if (dataKey.FieldType === "Select" || dataKey.DataType === "Select") {
							const matchingOption = dataKey.Options.find((option) => option.OptionLabel === parentValue);
							if (matchingOption) {
								postDataValue = {
									[dataKey.Name]: {
										dataKeyID: dataKey.ID,
										dataValue: {
											dataValueID: matchingOption.OptionID
										},
										parentName: dataKey.ParentName
									}
								};
								formDataValue = {
									[dataKey.Name]: {
										value: { label: matchingOption.OptionLabel, value: matchingOption.OptionID },
										disabled: formData[dataKey.Name]?.disabled,
										parentName: dataKey.ParentName
									}
								};
								if (dataKey.ParentName) {
									keysWithParent[dataKey.Name] = {
										bucketName: dataBucketName,
										parentName: dataKey.ParentName
									};
								}
							}
						} else {
							postDataValue = {
								[dataKey.Name]: {
									dataKeyID: dataKey.ID,
									dataValueIfFreeForm: parentValue
								}
							};
							formDataValue = {
								[dataKey.Name]: {
									value: parentValue,
									disabled: formData[dataKey.Name]?.disabled,
									parentName: dataKey.ParentName
								}
							};
							if (dataKey.ParentName) {
								keysWithParent[dataKey.Name] = {
									bucketName: dataBucketName,
									parentName: dataKey.ParentName
								};
							}
						}
						if (!postData[dataBucketName]) {
							postData[dataBucketName] = {};
						}
						Object.assign(postData[dataBucketName], postDataValue);
						Object.assign(formData, formDataValue);
					}
				});
			}
		});
		// Remove any values from keys if they have a parent but the parent value was not selected
		Object.keys(keysWithParent).forEach((dataKeyName) => {
			if (formData[keysWithParent[dataKeyName].parentName] && !formData[keysWithParent[dataKeyName].parentName].value) {
				formData[dataKeyName].value = "";
				delete postData[keysWithParent[dataKeyName].bucketName][dataKeyName];
			}
		});
		self.setState(
			{
				formData,
				postData
			},
			() => {
				callback?.();
			}
		);
	}
};

export default UpdateStateHelper;
